import styled from '@emotion/styled';
import LoadingSpinner from '@/components/LoadingSpinner';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

const LoadingSpinnerWrapper = styled('span')(
  ({ theme }) => ({
    padding: 7,
    width: 32,
    height: 32,
    backgroundColor: theme.palette.action.hover,
    boxSizing: 'border-box',
    '.MuiCircularProgress-root': {
      color: theme.palette.action.disabled,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    paddingLeft: 6,
    paddingRight: 6,
    backgroundColor: theme.isDark ? 'black' : undefined,
    borderRight: `2px solid ${theme.palette.divider}`,
    '.MuiCircularProgress-root': {
      color: theme.palette.text.primary,
    },
  })),
);

const ThumbnailLoadingPlaceholder = () => (
  <LoadingSpinnerWrapper>
    <LoadingSpinner size={18} />
  </LoadingSpinnerWrapper>
);

export default ThumbnailLoadingPlaceholder;
